import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./newSidebar.css";
import GetNotificationNoRead from "../Services/Magasin/NotificationNoRead";
import { NotificationMagasinType } from "../Modeles/NotificationModel";
import PanierLengVisiteur from "../Services/Panier/PanierLeng";
import EmptyCartPopup from "../components/EmptyCartPopup";

export interface NotificationState {
  Notifications: NotificationMagasinType[];
  messageErrosNotif: string;
}

const DashboardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);

const DocumentsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
    <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z"/>
  </svg>
);

const MessengerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
    <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5"/>
  </svg>
);
const DeplacementIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
  <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
</svg>
);
const ClientIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm9 1.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5M9 8a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4A.5.5 0 0 0 9 8m1 2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5m-1 2C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 0 2 13h6.96q.04-.245.04-.5M7 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0"/>
  </svg>
);

const ReportsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
    <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z"/>
  </svg>
);

const LogoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <circle cx="12" cy="12" r="3" />
    <path d="M12 1v6m0 6v6m8.66-9l-5.2 3m-6.92 4L3.34 14M20.66 17l-5.2-3m-6.92-4L3.34 7" />
  </svg>
);

const CommissionIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

const EnCompteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
    <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"/>
    <path d="M12 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
  </svg>
);

export const NewSideBarMagasins = () => {
  const MagasinId = localStorage.getItem("MagasinId");
  const MagasinName = localStorage.getItem("MagasinName");

  const [stateNotification, setStateNotification] = useState<NotificationState>({
    Notifications: [],
    messageErrosNotif: "Aucune Notification",
  });

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const location = useLocation();

  useEffect(() => {
    GetNotificationNoRead()
      .getNotif()
      .then((res) => {
        const unread = res.data.filter((notif: any) => notif.IsRead === 0);
        setStateNotification((prev) => ({ ...prev, Notifications: unread }));
      })
      .catch(() => {
        setStateNotification((prev) => ({
          ...prev,
          messageErrosNotif: "Aucune Notification",
        }));
      });
  }, []);
  const [PanierLen, setPanierLen] = useState("");
  const [showEmptyCartPopup, setShowEmptyCartPopup] = useState(false);
  const navigate = useNavigate();

  const fetchPanierLen = () => {
    PanierLengVisiteur(MagasinId, Type).GetLenPanier()
      .then((response: any) => { setPanierLen(response.data); })
      .catch((error: any) => { console.error("Error fetching panier:", error); });
  };

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const Type = "magasins";

  useEffect(() => {
    fetchPanierLen();
    // Listen for real-time updates from HomeMagasin
    const onPanierUpdated = () => fetchPanierLen();
    window.addEventListener("panier-updated", onPanierUpdated);
    return () => window.removeEventListener("panier-updated", onPanierUpdated);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const toggleSidebar = () => setIsCollapsed(!isCollapsed);
  const toggleMobileSidebar = () => setIsMobileOpen(!isMobileOpen);
  const closeMobileSidebar = () => setIsMobileOpen(false);

  const menuItems = [
    {
      paths: [`/magasins/${MagasinId}`],
      label: "Accueil",
      icon: DashboardIcon,
      exact: true,
    },
    {
      paths: [
        `/magasins/${MagasinId}/articles`,
        `/magasins/${MagasinId}/articles/add`,
      ],
      label: "Articles",
      icon: DocumentsIcon,
    },
    {
      paths: [
        `/magasins/${MagasinId}/deplacement`,
      ],
      label: "Deplacement",
      icon: DeplacementIcon,
    },

    {
      paths: [
        `/magasins/${MagasinId}/commercials`,
        `/magasins/${MagasinId}/commercials/add`,
      ],
      label: "Commercials",
      icon: MessengerIcon,
    },

    {
      paths: [
        `/magasins/${MagasinId}/clients`,
        `/magasins/${MagasinId}/clients/add`,
      ],
      label: "Clients",
      icon: ClientIcon,
    },
    {
      paths: [
        `/magasins/${MagasinId}/en-compte`,
      ],
      label: "En Compte",
      icon: EnCompteIcon,
    },
    {
      paths: [
        `/magasins/${MagasinId}/historiques`,
        `/magasins/${MagasinId}/commande`,
      ],
      label: "Suivi",
      icon: ReportsIcon,
    },
    {
      paths: [
        `/magasins/${MagasinId}/gestion-devis`,
      ],
      label: "Gestion des devis",
      icon: DocumentsIcon,
    }
  ];

  const isMobile = screenWidth <= 768;

  useEffect(() => {
    const offset = isMobile ? "0px" : isCollapsed ? "80px" : "220px";
    document.body.classList.add("app-has-sidebar");
    document.documentElement.style.setProperty("--app-sidebar-offset", offset);

    return () => {
      document.body.classList.remove("app-has-sidebar");
      document.documentElement.style.removeProperty("--app-sidebar-offset");
    };
  }, [isMobile, isCollapsed]);

  return (
    <>
      <EmptyCartPopup show={showEmptyCartPopup} onClose={() => setShowEmptyCartPopup(false)} />
      {/* Mobile Menu Trigger */}
      {isMobile && (
        <button className="mobile-menu-trigger-nsb" onClick={toggleMobileSidebar}>
          <i className="bi bi-list" />
        </button>
      )}

      {/* Overlay for mobile */}
      {isMobile && (
        <div
          className={`sidebar-overlay-nsb ${isMobileOpen ? "active-nsb" : ""}`}
          onClick={closeMobileSidebar}
        />
      )}

      {/* Notification Button (top-right) */}
      <div className="notification-btn-wrapper-nsb">
        <NavLink to={`/magasins/${MagasinId}/notifications`}>
          <button
            className={`notification-btn-nsb ${
              stateNotification.Notifications.length > 0 ? "radiate-nsb" : ""
            }`}
          >
            <i className="bi bi-bell" />
            {stateNotification.Notifications.length > 0 && (
              <span className="notif-badge-nsb">
                {stateNotification.Notifications.length}
              </span>
            )}
          </button>
        </NavLink>
      </div>

      {/* Sidebar */}
      <aside
        className={`sidebar-nsb ${isCollapsed ? "collapsed-nsb" : ""} ${
          isMobile && isMobileOpen ? "open-mobile-nsb" : ""
        }`}
      >
        <button className="toggle-sidebar-btn-nsb" onClick={toggleSidebar}>
          <i
            className={`bi ${
              isCollapsed ? "bi-chevron-right" : "bi-chevron-left"
            }`}
          />
        </button>

        <div className="sidebar-content-nsb">
          {/* User Profile */}
          <div className="user-profile-nsb">
            <div className="user-avatar-nsb">
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  background: "var(--gold-nsb)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "var(--ink-nsb)",
                }}
              >
                {MagasinName?.charAt(0)?.toUpperCase()}
              </div>
            </div>
            {!isCollapsed && (
              <div className="user-info-nsb">
                <h3>{MagasinName}</h3>
              </div>
            )}
          </div>

          {/* Navigation */}
          <nav className="sidebar-nav-nsb">
            {menuItems.map((item) => {
              let isActive = false;
              if (item.exact) {
                isActive = location.pathname === item.paths[0];
              } else {
                isActive = item.paths.some((path) =>
                  location.pathname.startsWith(path)
                );
              }

              return (
                <NavLink
                  key={item.label}
                  to={item.paths[0]}
                  className={`nav-item-nsb ${isActive ? "active-nsb" : ""}`}
                  title={isCollapsed ? item.label : ""}
                  onClick={isMobile ? closeMobileSidebar : undefined}
                >
                  {item.icon && <item.icon />}
                  <span>{item.label}</span>
                </NavLink>
              );
            })}
          </nav>

          {/* Bottom Section */}
          <div className="sidebar-bottom-nsb">
            <div className="bottom-actions-nsb">
              <NavLink
                to={`/magasins/${MagasinId}/paramétres`}
                className="action-btn-nsb"
                title={isCollapsed ? "Paramètres" : ""}
                onClick={isMobile ? closeMobileSidebar : undefined}
              >
                <SettingsIcon />
                <span>Paramètres</span>
              </NavLink>
              <NavLink
                to="/logout"
                className="logout-pro-btn"
                title={isCollapsed ? "Déconnecter" : ""}
                onClick={isMobile ? closeMobileSidebar : undefined}
              >
                <LogoutIcon />
                <span>Déconnecter</span>
              </NavLink>
            </div>
          </div>
        </div>
      </aside>

      {/* Mobile Bottom Navigation */}
      {/* {isMobile && (
        <nav className="mobile-bottom-nav-nsb">
          {menuItems.slice(0, 5).map((item) => {
            let isActive = false;
            if (item.exact) {
              isActive = location.pathname === item.paths[0];
            } else {
              isActive = item.paths.some((path) =>
                location.pathname.startsWith(path)
              );
            }

            return (
              <NavLink
                key={item.label}
                to={item.paths[0]}
                className={`mobile-nav-item-nsb ${isActive ? "active-nsb" : ""}`}
              >
                {item.icon && <item.icon />}
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
      )} */}

      {/* Floating Icons (bottom-right) */}
        <div className="floating-icons-nsb">
          <div className="tooltip-container-nsb" onClick={() => PanierLen && PanierLen.length > 0 ? navigate(`/magasins/${MagasinId}/panier`) : setShowEmptyCartPopup(true)} style={{ cursor: 'pointer' }}>
            <button className="floating-btn-nsb ticket-btn-nsb">
              <i className="bi bi-basket">{PanierLen.length}</i>
            </button>
            <span className="tooltip-text-nsb">Panier</span>
          </div>
        <NavLink to="/assistance">
          <div className="tooltip-container-nsb">
            <button className="floating-btn-nsb support-btn-nsb">
              <i className="bi bi-headset" />
            </button>
            <span className="tooltip-text-nsb">Support</span>
          </div>
        </NavLink>
        <NavLink to="/magasins/tickets">
          <div className="tooltip-container-nsb">
            <button className="floating-btn-nsb ticket-btn-nsb">
              <i className="bi bi-ticket-perforated-fill" />
            </button>
            <span className="tooltip-text-nsb">Ticket</span>
          </div>
        </NavLink>
      </div>
    </>
  );
};